import { gql } from '@apollo/client';

import { StudentPracticeSession } from '@ts-core/modules/practice/types';
import { studentFinishedPracticeSessionFragment } from '@ts-core/modules/practice/graphql/fragments';

export interface GetStudentPracticeSessionsQueryVariables {
  courseId: string;
  studentId: string;
}

export interface GetStudentPracticeSessionsQueryResult {
  studentPracticeSessions: StudentPracticeSession[];
}

export const getStudentPracticeSessionsQuery = gql`
  query GetStudentPracticeSessionsQuery($courseId: String!, $studentId: String!) {
    studentPracticeSessions(courseId: $courseId, studentId: $studentId)
      @rest(type: "StudentFinishedPracticeSession", path: "courses/{args.courseId}/students/{args.studentId}/practice") {
      ...StudentFinishedPracticeSession
    }
  }
  ${studentFinishedPracticeSessionFragment}
`;
